import React from 'react';
import VideoTrack from '../VideoTrack/VideoTrack';
import { useVideoContext } from '../../main';
import ParticipantMeetingPlaceholder from '../ParticipantInfo/ParticipantPlaceholder/ParticipantMeetingPlaceholder';
import { DNABox } from '@alucio/lux-ui';
var MediaAccessState;
(function (MediaAccessState) {
    MediaAccessState[MediaAccessState["unknown"] = 0] = "unknown";
    MediaAccessState[MediaAccessState["prompted"] = 1] = "prompted";
    MediaAccessState[MediaAccessState["allowed"] = 2] = "allowed";
    MediaAccessState[MediaAccessState["denied"] = 3] = "denied";
    MediaAccessState[MediaAccessState["notAvailable"] = 4] = "notAvailable";
    MediaAccessState[MediaAccessState["notFound"] = 5] = "notFound";
})(MediaAccessState || (MediaAccessState = {}));
export default function LocalVideoPreview(props) {
    if (props.videoAccessState === MediaAccessState.denied) {
        return React.createElement(ParticipantMeetingPlaceholder, Object.assign({}, props, { showTextErr: true }));
    }
    else if (props.videoAccessState === MediaAccessState.notAvailable) {
        return React.createElement(ParticipantMeetingPlaceholder, Object.assign({}, props, { showTextErr: true }));
    }
    else if (props.videoAccessState === MediaAccessState.notFound) {
        return React.createElement(ParticipantMeetingPlaceholder, Object.assign({}, props, { showTextErr: true }));
    }
    const { localTracks } = useVideoContext();
    const videoTrack = localTracks.find(track => track.name.includes('camera'));
    return videoTrack
        ? React.createElement(VideoTrack, { track: videoTrack, isLocal: true })
        : React.createElement(DNABox, { fill: true },
            React.createElement(ParticipantMeetingPlaceholder, Object.assign({}, props)));
}
//# sourceMappingURL=LocalVideoPreview.js.map